module.exports = __webpack_public_path__ + "static/media/testing-dude.6e4ae179.png";